/* Global this.$e methods */
import userFriendlyEr from './userFriendlyEr'
import {WALL} from "../config/config"

const e = {
  confirmBox (msg, title, confirmBtnText) {
    msg = this.$translate(msg || 'Удаленную запись нельзя будет восстановить')
    title = this.$translate(title || 'Удалить запись?')
    confirmBtnText = this.$translate(confirmBtnText || 'Удалить')
    return this.$confirm(msg, title, {
      confirmButtonText: confirmBtnText,
      cancelButtonText: this.$translate('Отмена'),
      type: 'warning',
      closeOnClickModal: false
    })
  },
  successBox (title) {
    title = this.$translate(title || 'Действие успешно завершено')
    this.$swal({
      position: 'center',
      type: 'success',
      title: title,
      showConfirmButton: false,
      timer: WALL.SUCCESS_TIMEOUT
    })
  },
  errorBox (er, options = {}) {
    this.$swal(Object.assign(options, {
      position: 'center',
      type: 'error',
      title: userFriendlyEr.recognize(er),
      showConfirmButton: false,
      timer: WALL.ERROR_TIMEOUT
    }))
  },
  warningBox (msg, duration) {
    this.$message({
      showClose: true,
      message: this.$translate(msg),
      type: 'warning',
      duration: duration || WALL.ERROR_TIMEOUT
    })
  }
}

export function installE (Vue) {
  Vue.prototype.$e = Object.assign(Vue.prototype, e)
}
